import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/services/authContext';
import { DATA_MODE } from '@/config/dataMode';

/**
 * Wraps the whole app shell. In demo mode this always renders children —
 * no login wall, matching current demo behavior exactly. In live mode it
 * blocks rendering until session state resolves, then redirects to
 * /login if unauthenticated (brief #18: "protected page becomes
 * inaccessible" after logout / for a direct unauthenticated hit).
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (DATA_MODE !== 'live') return <>{children}</>;
  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-3)' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
